/** Service Desk console: ang setup ng commerce profile at ang settings ng Pag-order at approval (SD-S2-21, WP-S2-H). */
export const serviceCommerce = {
  nav: { commerce: "Commerce profile", ordering: "Pag-order at approval" },
  commerce: {
    intro: "Ikinakabit ng commerce profile ang order system mo sa katalogo at mga order: aling connector ang daan, aling operation ang gumagawa ng bawat trabaho, at ano ang kahulugan ng mga status nito dito. Nasa Connectors pa rin ang sign-in, mga operation, log at kalusugan ng connector.",
    kind: { generic_rest: "REST connector", manual_csv: "CSV na katalogo" },
    requirement: { required: "Kailangan", recommended: "Inirerekomenda", optional: "Opsyonal" },
    roles: {
      list_products: "Ilista ang mga produkto",
      get_price: "Kunin ang presyo",
      get_stock: "Kunin ang stock",
      lookup_customer: "Hanapin ang customer",
      create_order: "Gumawa ng order",
      get_order: "Kunin ang order",
      list_orders: "Ilista ang mga order",
      cancel_order: "Kanselahin ang order",
      create_quote: "Gumawa ng quote",
      get_quote: "Kunin ang quote",
      get_invoice_status: "Kunin ang status ng invoice",
    },
    noAccess: { title: "Hindi mo makikita ang commerce profile", body: "Humingi ng access sa mga connector sa isang owner." },
    error: { title: "Hindi ma-load ang commerce profile", body: "Hindi apektado ang order system mo. Subukan ulit." },
    empty: { title: "Wala pang commerce profile", readOnly: "Magpa-set up sa isang taong namamahala ng mga connector." },
    create: {
      title: "I-set up ang commerce profile",
      intro: "Piliin kung paano aabot sa order system mo ang katalogo at mga order. Susunod ang pag-bind ng mga operation at pag-map ng mga status.",
      kind: "Paano pinapanatili ang katalogo mo?",
      rest: "Sa pamamagitan ng connector",
      restHint: "Dumadaan sa API na nakakonekta mo ang mga produkto, presyo at order.",
      csv: "Mula sa CSV file",
      csvHint: "Walang API: ikaw ang mag-a-upload ng katalogo at mag-ki-key in ng mga order sa system mo.",
      connector: "Connector",
      connectorHint: "Gumawa muna ng connector sa Connectors kung wala ito sa listahan.",
      chooseConnector: "Pumili ng connector",
      noConnectors: "Wala pang connector",
      name: "Pangalan ng profile",
      nameHint: "Para sa staff lang.",
      submit: "Gumawa ng profile",
      done: "Nagawa ang commerce profile.",
      problem: { name: "Bigyan ng pangalan ang profile.", connector: "Piliin ang connector." },
    },
    readiness: {
      catalogue: "Katalogo",
      ordering: "Pag-order",
      paused: "Naka-pause ang pag-order",
      missing: "I-bind ang mga kinakailangang operation para mabuksan ang pag-order: {{roles}}.",
    },
    reason: {
      paused: "Naka-pause ang pag-order.",
      no_connector: "Walang nakakabit na connector.",
      connector_unhealthy: "Hindi maayos ang connector.",
      missing_required: "May kinakailangang operation na hindi pa naka-bind.",
    },
    actions: {
      pause: "I-pause ang pag-order",
      pausedDone: "Naka-pause ang pag-order. Makakapag-browse pa rin ang mga kliyente.",
      resume: "Ituloy ang pag-order",
      resumed: "Bukas na ulit ang pag-order.",
      validate: "Suriin ang mga binding",
      valid: "Tugma sa canonical na kontrata ang bawat binding.",
      invalid: "May mga binding na kailangang ayusin.",
      connector: "Settings ng connector",
      catalogue: "Katalogo",
    },
    bindings: {
      title: "Mga operation bawat commerce role",
      label: "Mga commerce role na naka-bind sa mga operation ng connector",
      role: "Commerce role",
      operation: "Operation ng connector",
      state: "Kalagayan",
      notBound: "Hindi naka-bind",
      bindFor: "Operation para sa {{role}}",
      boundDone: "Naka-bind na ang {{role}}.",
      unboundDone: "Hindi na naka-bind ang {{role}}.",
      openOperation: "Buksan ang operation",
      noConnector: "Walang nakakabit na connector sa profile na ito, kaya walang operation na maibi-bind.",
      missing: "Kailangan: hindi naka-bind",
      unbound: "Hindi naka-bind",
      ok: "Tugma sa kontrata",
      problems_one: "{{count}} problema",
      problems_other: "{{count}} problema",
    },
    problem: {
      operation_unknown: "Hindi umiiral ang operation",
      not_published: "Hindi pa naka-publish ang operation",
      version_unknown: "Hindi umiiral ang bersyong iyon",
      kind_mismatch: "Maling uri ng operation para sa role na ito",
      format_not_json: "Hindi JSON ang sagot",
      mapping_missing: "Kulang ang mapping",
      mapping_invalid: "Hindi tama ang mapping",
      list_needs_items: "Kailangan ng items path ang listahan",
      output_missing: "May kinakailangang output na hindi na-map",
      output_one_of: "Mag-map ng kahit isa sa mga alternatibo",
      output_needed_for_batch: "Kailangan sa batch na tawag",
      input_missing: "May kinakailangang input na hindi ginagamit",
      paging_missing: "Hindi naka-set up ang paging",
      idempotency_missing: "Walang idempotency key na ipinapadala",
      reject_reasons_missing: "Hindi na-map ang mga dahilan ng pagtanggi",
      secret_in_request: "May lihim na nakasulat sa request",
      credential_header: "May credential header na tinype nang mano-mano",
    },
    statusMap: {
      title: "Pag-map ng status",
      label: "Mga status ng order ng system mo at ang kahulugan nito dito",
      intro: "I-map ang mga status na iniuulat ng system mo sa mga status na nakikita ng kliyente. Ang status na wala sa talahanayan ay babasahin bilang “{{fallback}}” at lalagyan ng bandila.",
      external: "Status sa system mo",
      canonical: "Kahulugan dito",
      choose: "Pumili ng status",
      noReason: "Walang dahilan",
      empty: "Wala pang na-map na status. Babasahin bilang pinoproseso ang bawat status na iuulat ng system mo.",
      externalFor: "Status {{n}} sa system mo",
      canonicalFor: "Kahulugan dito ng status {{n}}",
      reasonFor: "Dahilan ng pagtanggi para sa status {{n}}",
      removeRow: "Alisin ang status {{n}}",
      remove: "Alisin",
      add: "Magdagdag ng status",
      save: "I-save ang mapping",
      saved: "Na-save ang pag-map ng status.",
      problem: { incomplete: "Punan ang dalawang column sa bawat hilera.", duplicate: "Dalawang beses na-map ang mga status na ito: {{status}}." },
      tryLabel: "Subukan ang isang status",
      tryHint: "I-type ang status na ipinapadala ng system mo para makita kung paano ito binabasa.",
      try: "Suriin",
      resolved: "Binabasa bilang {{status}}",
      unmapped: "Wala sa talahanayan: binabasa bilang pinoproseso",
    },
  },
  ordering: {
    save: "I-save ang mga pagbabago",
    saved: "Na-save ang mga setting ng pag-order.",
    profileLink: "Commerce profile",
    empty: { title: "I-set up muna ang commerce profile", body: "Nakakabit sa commerce profile ang mga approval rule at limit sa pag-order.", cta: "Buksan ang commerce profile" },
    problem: { pesos: "Maglagay ng buong bilang ng piso." },
    approval: {
      title: "Mga approval rule",
      intro: "Inaaprubahan ng mga kliyente ang sarili nilang order sa portal nila. Nagdaragdag ang mga rule na ito ng desisyon ng team mo.",
      threshold: "Staff approval kapag lampas sa (₱)",
      thresholdHint: "Ang order na lampas sa halagang ito ay maghihintay ng miyembro ng team bago ipadala. Iwanang bakante kung walang threshold.",
      none: "Walang threshold",
      credit: "I-approve ang mga order ng organisasyong may credit hold",
      creditHint: "Kapag nag-ulat ng credit hold ang system mo, magpapasya ang isang miyembro ng team.",
      anomaly: "Suriin ang mga hindi karaniwang malaking order",
      anomalyHint: "Ang order na mas malaki nang husto kaysa sa pinakamalaki ng organisasyon sa nakaraang 90 araw ay mangangailangan ng miyembro ng team.",
      approvers: "Ang mga approver ay mga miyembro ng team na may “Mag-approve ng mga order” ang role. Ibigay ang pahintulot sa Mga role ng team.",
    },
    categories: {
      label: "Mga kategoryang laging nangangailangan ng approval",
      hint: "Ang anumang order na may produkto sa mga kategoryang ito ay maghihintay ng miyembro ng team.",
      add: "Idagdag",
      list: "Mga kategoryang nangangailangan ng approval",
      remove: "Alisin ang {{category}}",
    },
    stepUp: {
      title: "Step-up verification",
      intro: "Ang malalaking order ay nangangailangan ng bagong e-mail code mula sa kliyente bago kumpirmahin.",
      threshold: "Humingi ng code kapag katumbas o lampas sa (₱)",
      hint: "Buong bilang ng piso.",
    },
    stock: {
      title: "Stock at backorder",
      intro: "Ang mangyayari kapag mas marami ang inorder ng kliyente kaysa sa stock.",
      backorder: "Payagan ang backorder",
      backorderHint: "Makakapag-order ang mga kliyente ng item na ubos na; ipapakita ang lead time.",
      staffConfirm: "Maghihintay sa kliyente ang mga order na inilagay ng staff",
      staffConfirmHint: "Ang order na inilagay mo para sa kliyente ay kukumpirmahin ng kliyente, hindi para sa kanya.",
    },
    cancel: {
      title: "Patakaran sa pagkansela",
      intro: "Ang mangyayari kapag humiling ang kliyente na kanselahin ang order na naka-place na.",
      atSystem: "Kanselahin agad sa order system",
      atSystemHint: "Pinapatakbo agad ang cancel operation. Kapag off: tatanungin ang team at sila ang magkakansela doon.",
    },
  },
} as const;
